import { Events } from './events'
import Ping from 'ping.js'

class Network {
  static initNetworkStateListener() {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return
    if (navigator.onLine) {
      Events.dispatchEvent('online')
    } else {
      Events.dispatchEvent('offline')
    }
    window.addEventListener('online', function () {
      console.log('I am connected to the internet')
      Events.dispatchEvent('online')
    })

    window.addEventListener('offline', function () {
      console.log('Disconnected...so sad!!!')
      Events.dispatchEvent('offline')
    })
  }

  static initListenerForServiceWorker() {
    self.isConnected = true
    Events.handleEvent('online', () => {
      self.isConnected = true
    })
    Events.handleEvent('offline', () => {
      self.isConnected = false
    })
  }

  static sendRequestTo(url, data, method) {
    return request(method, url, null, data)
  }

  static sendRequestToWithRetries(url, data, method, nbRetries) {
    return request(method, url, null, data, nbRetries)
  }

  static sendGetRequest(url) {
    return request('get', url)
  }

  static sendGetRequestWithHeader(url, header) {
    return request('get', url, header)
  }

  static sendPostRequest(url, data) {
    return request('post', url, null, data)
  }

  static sendPutRequest(url, data) {
    return request('put', url, null, data)
  }

  static sendPutRequestWithHeader(url, header, data) {
    return request('put', url, header, data)
  }

  static sendDeleteRequest(url, data) {
    return request('delete', url, null, data)
  }

  static sendPostRequestWithHeader(url, header, data) {
    return request('post', url, header, data)
  }

  static defaultResponseParsing(response) {
    let parsed = {
      success: false,
      messageId: 'messages.unknownError',
    }
    if (response.status.code === 503) {
      parsed = {
        success: false,
        messageId: 'messages.serverNotAvailale',
      }
    } else if (response.status.code === 'not_connected') {
      parsed = {
        success: false,
        messageId: 'messages.badNetwork',
        networkError: true,
      }
    }
    // console.warn(parsed, response)
    return parsed
  }
}

async function request(
  method,
  url,
  headers = null,
  data = null,
  maxRetry = 1,
  nbRetries = 0,
) {
  const isConnected = await checkIsConnected()
  if (!isConnected) {
    if (maxRetry && maxRetry > Math.min(nbRetries, 20))
      return request(method, url, headers, data, maxRetry, nbRetries + 1)
    return {
      status: { code: 'not_connected' },
      response: null,
    }
  }
  const requestConfig = {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...(headers || {}),
    },
  }
  if (data) requestConfig.body = JSON.stringify(data)
  let dataToReturn = {
    status: { code: 'not_connected' },
    response: null,
  }
  try {
    const response = await fetch(url, requestConfig)
    dataToReturn = {
      status: { code: response.status },
      response: await response.json(),
    }
  } catch (error) {
    console.warn(error)
  }
  return dataToReturn
}

async function checkIsConnected() {
  // if (!self.isConnected) return true

  const isConnected = await new Ping({ timeout: 10000 })
    .ping('https://google.com')
    .then(data => {
      return true
    })
    .catch(data => {
      console.log('ping is non ok')
      return false
    })
  return isConnected
}

export { Network }
